import React, { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconClose } from '@americanexpress/dls-icons';
import { IconButton } from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import { useRoomsContext } from '../../contexts/roomsContext';
import { useConfigContext } from '../../contexts/configContext';
import { useRefsContext } from '../../contexts/refsContext';

const RemoveRoomButton = memo(({ roomIndex }) => {
  const { removeRoom } = useRoomsContext();
  const { moduleId } = useConfigContext();
  const { updateRemoveButtons } = useRefsContext();
  const { formatMessage } = useIntl();

  const roomId = roomIndex + 1;

  const ref = useRef(null);

  useEffect(() => {
    if (roomIndex && !!ref?.current) {
      updateRemoveButtons(roomIndex, ref);
    }
  }, [ref, roomIndex, updateRemoveButtons]);

  const handleRemoveRoom = () => {
    removeRoom(roomIndex);
    updateRemoveButtons(roomIndex, null);
  };

  return (
    <IconButton
      screenReaderLabel={`${formatMessage({ id: 'remove' })} ${formatMessage({ id: 'roomNumber' }, { roomId })}`}
      aria-label={`${formatMessage({ id: 'remove' })} ${formatMessage({ id: 'roomNumber' }, { roomId })}`}
      onClick={handleRemoveRoom}
      reactlytics={{
        element: 'removeRoom',
      }}
      ref={ref}
      id={`${moduleId}_room${roomId}-removeRoomButton`}
      variant="tertiary"
    >
      <IconClose
        size="md"
      />
    </IconButton>
  );
});

RemoveRoomButton.displayName = 'RemoveRoomButton';

RemoveRoomButton.propTypes = {
  roomIndex: PropTypes.number.isRequired,
};

export default RemoveRoomButton;
